var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.06055 0L-0.000113487 1.06066L5.53022 6.59099L11.0605 1.06066L9.99989 0L5.53022 4.46967L1.06055 0Z","fill":"white"}));
}

ArrowDown.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
